import { environmentCommon } from '../../../environments/environment-common';

export const BRAND_PAGES: { url: string, icon: string, name: string }[] = [
  { url: environmentCommon.website.twitter.url + '/' + environmentCommon.company.social.twitter,
    icon: environmentCommon.website.twitter.cssClass, name: 'Twitter' },
  { url: environmentCommon.website.github.url + '/' + environmentCommon.company.social.github,
    icon: environmentCommon.website.github.cssClass, name: 'GitHub' },
  { url: environmentCommon.website.linkedin.companyUrl + '/' + environmentCommon.company.social.linkedin,
    icon: environmentCommon.website.linkedin.cssClass, name: 'LinkedIn' },
  { url: environmentCommon.website.instagram.url + '/' + environmentCommon.company.social.instagram,
    icon: environmentCommon.website.instagram.cssClass, name: 'Instagram' },
  { url: environmentCommon.website.pinterest.url + '/' + environmentCommon.company.social.pinterest,
    icon: environmentCommon.website.pinterest.cssClass, name: 'Pinterest' },
  { url: environmentCommon.website.medium.url + '/' + environmentCommon.company.social.medium,
    icon: environmentCommon.website.medium.cssClass, name: 'Medium' },
]
